import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { AbbButtonComponent } from '@components/abb-button/abb-button.component';

const radiusSizeClassMapper: Record<'small' | 'medium' | 'large', string> = {
  small: 'rounded-sm',
  medium: 'rounded',
  large: 'rounded-md',
};

@Component({
  selector: 'abb-simple-card',
  standalone: true,
  imports: [CommonModule, AbbButtonComponent],
  template: `
    <div
      [ngClass]="radiusSizeClass()"
      class="w-full bg-abb-background mat-elevation-z8 shadow-abb-gray-03 flex py-5 px-6 flex-col gap-3"
    >
      @if(title()||editable()||subtitle()) {
      <div class="w-full flex flex-col gap-1">
        <div class="flex justify-between items-center gap-x-4 relative">
          @if(title()) {
          <span class="text-xs text-abb-font/80 font-semibold uppercase">{{
            title()
          }}</span>
          } @if (editable()) {
          <abb-button
            id="edit"
            variant="none"
            class="flex-1 justify-end absolute right-0 text-abb-font/85"
            (onclick)="handleEdit()"
            [icon]="!editWithModal() && editing() ? 'mat/done' : 'mat/edit'"
            [iconExternalSize]="'text-lg'"
          />
          }
        </div>
        @if(subtitle()) {
        <span class="text-[10px] text-abb-font/80 font-medium">{{
          subtitle()
        }}</span>
        }
      </div>
      }
      <div class="flex flex-col flex-1 justify-start">
        <ng-content select="[content]"></ng-content>
      </div>

      <ng-content select="[footer]"></ng-content>
    </div>
  `,
  styles: ``,
  host: {
    class: 'w-full flex',
  },
})
export class AbbSimpleCardComponent {
  radiusSize = input<'small' | 'medium' | 'large'>('medium');
  radiusSizeClass = computed(() => radiusSizeClassMapper[this.radiusSize()]);
  title = input<string | undefined>(undefined);
  subtitle = input<string | undefined>(undefined);
  editable = input(false);
  editing = signal<boolean>(false);
  edit = output<boolean>();
  editWithModal = input<boolean>(false);

  handleEdit() {
    this.editing.set(!this.editing());
    this.edit.emit(this.editing());
  }
}
